import React, { useRef } from 'react'
import MainForm from './MainForm'

interface DemoFormProps {
  fieldIdPrefix: string
  privacyStatementCenter?: boolean
  region?: string
}

const POSDemoForm = ({
  fieldIdPrefix,
  privacyStatementCenter = false,
  region = 'US'
}: DemoFormProps) => {
  const fields = []
  fields.push({
    title: 'First and last name*',
    fieldLabel: 'First and last name*',
    marketoFieldName: 'mkoFullName',
    isRequired: true,
    fieldInputNameMarketoRestApi: 'mkoFullName',
    fieldType: 'Text',
    fieldOptions: [],
    fieldDependentId: '',
    classes: '!mb-4',
    __typename: 'ContentfulMdsFormField'
  })
  fields.push({
    title: 'Email*',
    fieldLabel: 'Email*',
    marketoFieldName: 'Email',
    isRequired: true,
    fieldInputNameMarketoRestApi: 'email',
    fieldType: 'Email',
    fieldOptions: [],
    fieldDependentId: '',
    classes: '!mb-4',
    __typename: 'ContentfulMdsFormField'
  })
  fields.push({
    title: 'Phone*',
    fieldLabel: 'Phone*',
    marketoFieldName: 'Phone',
    isRequired: true,
    fieldInputNameMarketoRestApi: 'phone',
    fieldType: 'Phone',
    fieldOptions: [],
    fieldDependentId: '',
    classes: '!mb-4',
    __typename: 'ContentfulMdsFormField'
  })
  fields.push({
    title: 'Restaurant Name*',
    fieldLabel: 'Restaurant Name*',
    marketoFieldName: 'Company',
    isRequired: true,
    fieldInputNameMarketoRestApi: 'company',
    fieldType: 'Text',
    fieldOptions: [],
    fieldDependentId: '',
    classes: '!mb-4',
    __typename: 'ContentfulMdsFormField'
  })
  if (region === 'US') {
    fields.push({
      title: 'Primary restaurant location zip code*',
      fieldLabel: 'Primary restaurant location zip code*',
      marketoFieldName: 'postalCode',
      isRequired: true,
      fieldInputNameMarketoRestApi: 'postalCode',
      fieldType: 'Text',
      fieldOptions: [],
      fieldDependentId: '',
      classes: '!mb-4',
      __typename: 'ContentfulMdsFormField'
    })
    fields.push({
      title: 'Which best describes you?*',
      fieldLabel: 'Which best describes you?*',
      marketoFieldName: 'toastType',
      isRequired: true,
      fieldInputNameMarketoRestApi: 'toastType',
      fieldType: 'Select (Dropdown)',
      fieldOptions: [
        {
          key: "I'm interested in buying Toast",
          value: "I'm interested in buying Toast"
        },
        {
          key: "I'm already a Toast customer",
          value: "I'm already a Toast customer"
        },
        { key: "I'm a restaurant guest", value: "I'm a restaurant guest" }
      ],
      fieldDependentId: '',
      classes: '!mb-4',
      __typename: 'ContentfulMdsFormField'
    })
  } else {
    let defaultValue = ''
    if (region === 'CA') {
      defaultValue = 'Canada'
    } else if (region === 'IE') {
      defaultValue = 'Ireland'
    } else if (region === 'UK') {
      defaultValue = 'United Kingdom'
    }
    fields.push({
      title: 'Select Country*',
      fieldLabel: 'Select Country*',
      marketoFieldName: 'country',
      isRequired: false,
      fieldInputNameMarketoRestApi: 'country',
      fieldType: 'Select (Dropdown)',
      fieldOptions: [
        { key: 'United States', value: 'United States' },
        { key: 'Canada', value: 'Canada' },
        { key: 'Ireland', value: 'Ireland' },
        { key: 'United Kingdom', value: 'United Kingdom' }
      ],
      defaultValue: defaultValue,
      fieldDependentId: '',
      classes: '!mb-4',
      __typename: 'ContentfulMdsFormField'
    })
    fields.push({
      title: 'Which best describes you?*',
      fieldLabel: 'Which best describes you?*',
      marketoFieldName: 'toastType',
      isRequired: true,
      fieldInputNameMarketoRestApi: 'toastType',
      fieldType: 'Select (Dropdown)',
      fieldOptions: [
        {
          key: "I'd like a restaurant consultation",
          value: "I'm interested in restaurant technology"
        },
        {
          key: "I'm already a Toast customer",
          value: "I'm a Toast customer looking for help"
        },
        {
          key: "I'm a restaurant guest",
          value: "I'm a restaurant guest looking for help"
        }
      ],
      fieldDependentId: '',
      classes: '!mb-4',
      __typename: 'ContentfulMdsFormField'
    })
    fields.push({
      marketoFieldName: 'optIn',
      fieldLabel:
        'Toast may send me additional communications to offer Toast products and services, including via SMS message. I can revoke my consent at any time.',
      isRequired: false,
      fieldInputNameMarketoRestApi: 'optIn',
      fieldType: 'Checkbox (Single/Multi Select)',
      fieldDependentId: '',
      classes: '!mb-4',
      __typename: 'ContentfulMdsFormField'
    })
  }
  const steps = [] as any
  steps.push({ coreFields: fields })
  const ref = useRef(null)
  return (
    <div ref={ref}>
      <MainForm
        componentContext='ContentfulMdsHero5050'
        description=''
        disclaimer=''
        entryId=''
        fieldIdPrefix={fieldIdPrefix}
        formCookie='toastDemoFormPOS'
        formSteps={steps}
        heading='Schedule Your Free Demo'
        heapInteractionSubmit='hpbottomdemo_submit'
        marketoId={region === 'US' ? '1003' : '1235'}
        region={region}
        submitLabel='Get a Demo'
        marketoProgramName={
          region !== 'US'
            ? region + '-Website-Demo-Request'
            : 'Website-Demo-Request'
        }
        thankYouPageURL={
          region !== 'US'
            ? '/' + region.toLowerCase() + '/request-demo-confirmed'
            : '/request-demo-confirmed'
        }
      />
    </div>
  )
}

export default POSDemoForm
